import { prepareForSlot } from '@mui/base'
import { clsx } from 'clsx'
import { type ComponentProps, type JSX } from 'react'

const SliderThumbSlot = prepareForSlot(function SliderThumb(
  props: ComponentProps<'span'>,
): JSX.Element {
  const { className, ...rest } = props

  return <span className={clsx('slider__thumb', className)} {...rest} />
})

export const SliderThumb = SliderThumbSlot
